import { clientAllocate } from '@fiverr-private/experiments_package';

export const allocateToExperiments = (experiments = [], biParams = {}) =>
    experiments.forEach(
        ({ experiment_id: experimentId, experiment_type: experimentType, num_of_groups: numOfGroups }) =>
            clientAllocate({
                numOfGroups,
                experimentId,
                experimentType,
                rolloutResult: true,
                enrichment: {
                    ...biParams,
                },
            })
    );
